module.exports = __webpack_public_path__ + "img/hotel-olissippo-oriente.57139684.jpg";